export const USER_SESSION = 'USER-SESSION';

export const USER_DATA = 'USER_DATA';

export const STUDENTS_ROWS = 30;

export const userTypeOptions = [
  { label: 'Administrativo', value: 'Administrator' },
  { label: 'Director', value: 'Director' },
  { label: 'Docente', value: 'Teacher' }
];

export const usersLinks = {
  administrator: [
    { path: '/alumnos', label: 'ALUMNOS' },
    { path: '/reportes', label: 'REPORTES' }
  ],
  director: [
    { path: '/alumnos', label: 'ALUMNOS' },
    { path: '/docentes', label: 'DOCENTES' },
    { path: '/evaluaciones-director', label: 'EVALUACIONES' }
  ],
  teacher: [
    { path: '/alumnos', label: 'ALUMNOS' },
    { path: '/evaluaciones', label: 'EVALUACIONES' },
    { path: '/mis-alumnos', label: 'MIS ALUMNOS' }
  ]
};

export const categoriesStudents = [
  { label: 'Bonificado', value: 'bonificado' },
  { label: 'Convenio', value: 'convenio' },
  { label: 'Licitación', value: 'licitacion' },
  { label: 'Otros', value: 'otros' }
];

export const familyCompositions = [
  { label: 'Madre', value: 'madre' },
  { label: 'Padre', value: 'padre' },
  { label: 'Madre y Padre', value: 'madre y padre' },
  { label: 'Madre y Hermanos', value: 'madre y hermanos' },
  { label: 'Padre y Hermanos', value: 'padre y hermanos' },
  { label: 'Madre, Padre y Hermanos', value: 'madre, padre y hermanos' },
  { label: 'Tutores', value: 'tutores' },
  { label: 'Tutores y Hermanos', value: 'tutores y hermanos' },
  { label: 'Institución', value: 'institución' },
];

export const howFindUs = [
  { label: 'Recomendación', value: 'Recomendación' },
  { label: 'Página Web', value: 'Página Web' },
  { label: 'Redes sociales', value: 'Redes sociales' },
  { label: 'Licitación', value: 'Licitación' },
  { label: 'Otros', value: 'Otros' }
];

export const relationTypes = [
  { label: 'Madre', value: 'Madre' },
  { label: 'Padre', value: 'Padre' },
  { label: 'Tutor', value: 'Tutor' }
];

export const educationLevels = [
  { label: 'Primaria incompleta', value: 'Primaria incompleta' },
  { label: 'Primaria completa', value: 'Primaria completa' },
  { label: 'Secundaria incompleta', value: 'Secundaria incompleta' },
  { label: 'Secundaria completa', value: 'Secundaria completa' },
  { label: 'Terciaria incompleta', value: 'Terciaria incompleta' },
  { label: 'Terciaria completa', value: 'Terciaria completa' }
];

export const occupations = [
  { label: 'Empleado', value: 'Empleado' },
  { label: 'Profesional', value: 'Profesional' },
  { label: 'Cuenta propia', value: 'Cuenta propia' },
  { label: 'No tiene', value: 'No tiene' }
];



// WEBPACK FOOTER //
// ./src/constants/constants.js